// ─── Invite Code Utilities (client-side) ─────────────────────────────────────
//
// IMPORTANT: Actual codes and validation live server-side in the
// redeemInviteCode Cloud Function. This file only provides a lightweight
// format check for instant UX feedback in the signup form.
// The real validation + redemption happens via the callable Cloud Function.

/** Quick format check for UX feedback — does NOT confirm the code is valid */
export function looksLikeInviteCode(code: string): boolean {
  return /^GATM-[A-Z0-9]{6}$/i.test(code.trim());
}
